import { Button } from "@leap4/frontend";

interface ActiveToggleButtonProps {
  active: boolean;
  onToggle: (next: boolean) => void;
}

const ActiveToggleButton = ({ active, onToggle }: ActiveToggleButtonProps) => (
  <Button
    variant="contained"
    disableElevation
    size="small"
    onClick={() => onToggle(!active)}
    style={{
      minWidth: 96,
      color: "#ffffff",
      background: active ? "#2e7d32" : "#9e9e9e",
      backgroundImage: "none",
    }}
  >
    {active ? "Active" : "Inactive"}
  </Button>
);

export default ActiveToggleButton;
